import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../withRoot';
import DiceUtil from '../utils/DiceUtil';
import { IconButton, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, FormControl, InputLabel, Select, MenuItem, Switch, List, ListItem, ListItemText, Collapse, ListItemSecondaryAction, Table, TableHead, TableRow, TableCell, TableBody, Checkbox } from '@material-ui/core';
import CasinoIcon from '@material-ui/icons/Casino';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Weapons from './Weapons.json';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    expansion: {
        width: "100%",
    },
    listText: {
        width: "180px",
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
});

class WeaponRoller extends Component {
    constructor(props) {
        super(props);

        this.state = {
            result: null,
            type: -1,
            range: -1,
            subtypes: Array(Weapons.subtypes.length).fill(2),
            damageTypes: Array(Weapons.damageTypes.length).fill(true),
            sources: Array(Weapons.sources.length).fill(true),
            isOpen: {},
        };
    }

    handleOpenChange = name => () => {
        const isOpen = Object.assign({}, this.state.isOpen, { [name]: !this.state.isOpen[name] });
        this.setState({
            isOpen: isOpen,
        });
    };

    setType(event) {
        this.setState({ type: event.target.value });
    }

    setRange(event) {
        this.setState({ range: event.target.value });
    }

    handleSubtypeToggle = index => () => {
        const subtypes = this.state.subtypes.concat();
        subtypes[index] = (subtypes[index] + 1) % 3;
        this.setState({ subtypes: subtypes });
    };

    handleDamageTypeToggle = index => () => {
        const damageTypes = this.state.damageTypes.concat();
        damageTypes[index] = !damageTypes[index];
        this.setState({ damageTypes: damageTypes });
    };

    handleSourceToggle = index => () => {
        const sources = this.state.sources.concat();
        sources[index] = !sources[index];
        this.setState({ sources: sources });
    };

    isWeaponInFilter(weapon) {
        if (this.state.type >= 0 && Weapons.types[this.state.type] !== weapon.type) return false;
        if (this.state.range >= 0 && Weapons.ranges[this.state.range] !== weapon.range) return false;

        const damageTypes = this.state.damageTypes;
        for (let i = 0; i < damageTypes.length; i++) {
            if (!damageTypes[i] && weapon.damageType === Weapons.damageTypes[i]) return false;
        }

        const sources = this.state.sources;
        for (let i = 0; i < sources.length; i++) {
            if (!sources[i] && weapon.source === Weapons.sources[i]) return false;
        }

        const subtypes = this.state.subtypes;
        const subtypeRequired = [];
        const subtypeBanned = [];
        for (let i = 0; i < subtypes.length; i++) {
            if (subtypes[i] === 0) {
                subtypeBanned[subtypeBanned.length] = Weapons.subtypes[i];
            } else if (subtypes[i] === 1) {
                subtypeRequired[subtypeRequired.length] = Weapons.subtypes[i];
            }
        }

        if (subtypeRequired.length > 0 && (!weapon.subtype || subtypeRequired.indexOf(weapon.subtype) === -1)) {
            return false;
        }

        if (subtypeBanned.length > 0 && weapon.subtype && subtypeBanned.indexOf(weapon.subtype) !== -1) {
            return false;
        }

        return true;
    }

    getWeaponsInFilter() {
        const myWeapons = [];
        for (let i = 0; i < Weapons.values.length; i++) {
            let weapon = Weapons.values[i];
            if (this.isWeaponInFilter(weapon)) {
                myWeapons[myWeapons.length] = weapon;
            }
        }
        return myWeapons;
    }

    rollWeapon() {
        const myWeapons = this.getWeaponsInFilter();
        const roll = DiceUtil.dice(myWeapons.length) - 1;
        this.setState({ result: myWeapons[roll].name });
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Filters</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="type">Type</InputLabel>
                            <Select value={this.state.type} onChange={(event) => this.setType(event)} inputProps={{ id: 'type' }}>
                                <MenuItem value={-1}>All</MenuItem>
                                {Weapons.types.map((value, index) => (
                                    <MenuItem key={index} value={index}>{value}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="range">Range</InputLabel>
                            <Select value={this.state.range} onChange={(event) => this.setRange(event)} inputProps={{ id: 'range' }}>
                                <MenuItem value={-1}>All</MenuItem>
                                {Weapons.ranges.map((value, index) => (
                                    <MenuItem key={index} value={index}>{value}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <List>
                            <ListItem button onClick={this.handleOpenChange("subtype")}>
                                <ListItemText primary="Sub Type" />
                                {this.state.isOpen["subtype"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            <Collapse in={this.state.isOpen["subtype"]}>
                                <List component="div" disablePadding>
                                    {Weapons.subtypes.map((value, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={value} />
                                            <ListItemSecondaryAction>
                                                {
                                                    this.state.subtypes[index] === 2 ?
                                                        (<Checkbox checked={this.state.subtypes[index]} value={index} onClick={this.handleSubtypeToggle(index)} indeterminate />) :
                                                        (<Checkbox checked={this.state.subtypes[index]} value={index} onClick={this.handleSubtypeToggle(index)} />)
                                                }
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>

                        <List>
                            <ListItem button onClick={this.handleOpenChange("damageType")}>
                                <ListItemText primary="Damage Type" />
                                {this.state.isOpen["damageType"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            <Collapse in={this.state.isOpen["damageType"]}>
                                <List component="div" disablePadding>
                                    {Weapons.damageTypes.map((value, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={value} />
                                            <ListItemSecondaryAction>
                                                <Switch onChange={this.handleDamageTypeToggle(index)} checked={this.state.damageTypes[index]} />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>

                        <List>
                            <ListItem button onClick={this.handleOpenChange("source")}>
                                <ListItemText primary="Source" />
                                {this.state.isOpen["source"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            <Collapse in={this.state.isOpen["source"]}>
                                <List component="div" disablePadding>
                                    {Weapons.sources.map((value, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={value} className={classes.listText} />
                                            <ListItemSecondaryAction>
                                                <Switch onChange={this.handleSourceToggle(index)} checked={this.state.sources[index]} />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>

                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Weapons</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Damage Type</TableCell>
                                    <TableCell>Properties</TableCell>
                                    <TableCell>Source</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getWeaponsInFilter().map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">{value.name}</TableCell>
                                        <TableCell>{value.type + " " + value.range + (value.subtype ? " (" + value.subtype + ")" : "")}</TableCell>
                                        <TableCell>{value.damageType}</TableCell>
                                        <TableCell>{value.properties ? value.properties.map(p => p).reduce((prev, curr) => [prev, ', ', curr]) : null}</TableCell>
                                        <TableCell>{value.source}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <Typography>
                    <IconButton color="inherit" aria-label="Roll" onClick={() => this.rollWeapon()}>
                        <CasinoIcon />
                    </IconButton>

                    {this.state.result}
                </Typography>
            </div>
        );
    }
}

WeaponRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Weapons Roller", withStyles(styles)(WeaponRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/WeaponRoller.js